import { useStaticQuery, graphql } from 'gatsby';
import React from 'react';
import Helmet, { HelmetProps } from 'react-helmet';

interface SEOProps {
  description?: string;
  lang?: string;
  meta?: [];
  keywords: string[];
  title: string;
  image?: string;
  author?: string;
  location: Location
}

const SEO: React.FC<SEOProps & HelmetProps> = ({
  description,
  lang = 'en',
  meta = [],
  keywords = [],
  location,
  ...props
}) => {
  const { site } = useStaticQuery(graphql`
    query DefaultSEOQuery {
      site {
        siteMetadata {
          title
          description
          author
          siteUrl
          defaultCover
        }
      }
    }
  `);

  const metaDescription = description || site.siteMetadata.description;
  const url = `${site.siteMetadata.siteUrl}${location.pathname}`
  const title = `${props.title} | ${site.siteMetadata.title}`
  const author = props.author || site.siteMetadata.author
  const image = props.image || site.siteMetadata.defaultCover

  const itemListElement = [
    {
      '@type': 'ListItem',
      item: {
        '@id': site.siteMetadata.siteUrl,
        name: 'Homepage',
      },
      position: 1,
    },
  ]

  if(location.pathname && location.pathname !== '/'){
    itemListElement.push({
      '@type': 'ListItem',
      item: {
        '@id': url,
        name: props.title,
      },
      position: 2,
    })
  }


  const breadcrumb = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    description: 'Breadcrumbs list',
    name: 'Breadcrumbs',
    itemListElement,
  }

  return (
    <Helmet htmlAttributes={{
      lang,
    }} {...props}>
      <title>{title}</title>
      <link rel="canonical" href={url} />
      <meta name="description" content={metaDescription} />
      {image && <meta name="image" content={image} />}
      <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>

      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      {image && <meta property="og:image" content={image} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={author} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  )
};

export default SEO;
